import React from "react";
import { Typography } from "@mui/material";
import logo from "../pages/logo.png";
export default function HomeBanner() {
  return (
    <div>
      <div className="homeBanner text-white d-flex align-items-center">
        <div className="container pt-5 pb-5">
          <div className="d-none  d-lg-block text-center">
            <img
              src={logo}
              height={160}
              width={180}
              alt="logo"
              className="mb-3"
            />
            <Typography
              variant="h3"
              textTransform={"uppercase"}
              fontWeight={700}
              gutterBottom
            >
              {new Date().getFullYear()} POLICY MEETING & 4<sup>th</sup> Edition
              of NATAP-M Awards
              {/* 2021 & 2022 NATAP-M Award Registration Portal */}
            </Typography>
          </div>
          <div className="d-block d-lg-none text-center">
            <img
              src={logo}
              height={80}
              width={100}
              alt="logo"
              className="mb-3"
            />
            <Typography
              variant="h5"
              textTransform={"uppercase"}
              fontWeight={700}
              gutterBottom
            >
              {new Date().getFullYear()} POLICY MEETING & 4<sup>th</sup> Edition
              of NATAP-M Awards
              {/* 2021 & 2022 NATAP-M Award Registration Portal */}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
}
